// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1_TzM","cls2":"ImpactHubModal-cls2_fWl ImpactHubModal-cls1_TzM"};